import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Container } from 'semantic-ui-react';
import TableBlockView from '@plone/volto-slate/blocks/Table/TableBlockView';

/* STYLE */
import '@redturtle/volto-io-studio/components/Blocks/Table/Table.less';

const View = (props) => {
  const { data } = props;

  return (
    <div
      className={cx('block-wrapper slateTable full-width', {
        ['has--bg--' + data?.table?.bg]: data?.table?.bg,
      })}
    >
      <Container>
        {data?.table?.title && <h2 className="title">{data.table.title}</h2>}
        <TableBlockView {...props} />
      </Container>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */

View.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
